import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const HelpCenterSettingsSupportWebsiteAppEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-help-center-setting-support-website-app" */ './src/ui'),
	),
	getPreloadProps: () => {
		return {};
	},
});
